import { useTranslation } from 'react-i18next';
import { LandingLayout } from './LandingLayout';
import { LandingHeader } from './components/LandingHeader';
import { LandingFooter } from './components/LandingFooter';
import { Seo } from './seo/Seo';
import { stripSplit } from './lib/splitMarker';
import { Hero } from './sections/Hero';
import { FeatureShowcase } from './sections/FeatureShowcase';
import { Licensing } from './sections/Licensing';
import { WhyStreamko } from './sections/WhyStreamko';
import { Comparison } from './sections/Comparison';
import { HowItWorks } from './sections/HowItWorks';
import { Features } from './sections/Features';
import { Confidence } from './sections/Confidence';
import { Pricing } from './sections/Pricing';
import { Faq } from './sections/Faq';

export function LandingPage() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const locale: 'en' | 'uk' | 'de' = lang === 'uk' || lang === 'de' ? lang : 'en';

  return (
    <LandingLayout header={<LandingHeader />} footer={<LandingFooter />}>
      <Seo
        title={stripSplit(t('landing.hero.title'))}
        description={t('landing.hero.subtitle')}
        path={locale === 'en' ? '/' : `/${locale}`}
        locale={locale}
        alternates={[
          { locale: 'en', path: '/' },
          { locale: 'uk', path: '/uk' },
          { locale: 'de', path: '/de' },
        ]}
      />
      <Hero />
      {/* Redesign order: the two phone showcases are adjacent (Music 01,
          Automation 02), then Licensing (03). */}
      <FeatureShowcase
        id="music"
        ns="music"
        nextAnchor="automation"
        phoneSrc="/images/landing/showcase-music-phone.png"
        phoneMaxW={{ base: '300px', lg: '440px' }}
        card1Pos={{ top: '1%', left: '86%', w: '44%' }}
        card2Pos={{ top: '76%', right: '77%', w: '53%' }}
        conn1={{ src: '/images/landing/sc-music-conn-1.png', top: '5%', left: '48.6%', w: '37.4%' }}
        conn2={{ src: '/images/landing/sc-music-conn-2.png', top: '33%', left: '22.8%', w: '17.8%' }}
        dots={[
          { left: '48.7%', top: '11.5%' },
          { left: '40.6%', top: '33%' },
        ]}
      />
      <FeatureShowcase
        id="automation"
        ns="automation"
        nextAnchor="licensing"
        bgGradient="linear(140deg, #fffaf9 22%, #fbe5d8 83%)"
        phoneSrc="/images/landing/showcase-automation-phone.png"
        phoneMaxW={{ base: '230px', lg: '262px' }}
        card1Pos={{ top: '18.6%', left: '108%', w: '60%' }}
        card2Pos={{ top: '68%', right: '114.5%', w: '88%' }}
        conn1={{ src: '/images/landing/sc-auto-conn-1.png', top: '25%', left: '56.2%', w: '51.8%' }}
        conn2={{ src: '/images/landing/sc-auto-conn-2.png', top: '42%', left: '-14.7%', w: '28.8%' }}
        dots={[
          { left: '56.5%', top: '29.6%' },
          { left: '14.1%', top: '42%' },
          { left: '14.1%', top: '55.3%' },
        ]}
      />
      <Licensing />
      <WhyStreamko />
      <Comparison />
      <HowItWorks />
      <Features />
      <Confidence />
      <Pricing />
      <Faq />
    </LandingLayout>
  );
}

export default LandingPage;
